export const deviceStatusPageSize=10;
export const startDateLimit=89
export const commonHeaders = {
    // serialNumber: "S.No",
    ts: {label:"Timestamp",tooltip:""},
};